import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';

export default class PartGoodReceiptFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.purchaseOrderId  = '';
		this.purchaseOrderPurchaseOrderNumber = '';
		this.purchaseOrderNumber = '';
		this.partGoodReceiptNumber = '';
		this.partGoodReceiptDateFrom = '';
		this.partGoodReceiptDateTo = '';
		this.suratJalan = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			purchaseOrderId : '0',
			purchaseOrderPurchaseOrderNumber : '0',
			purchaseOrderNumber : '0',
			partGoodReceiptNumber : '0',
			partGoodReceiptDateFrom : '0',
			partGoodReceiptDateTo : '0',
			suratJalan : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}